import { lazy } from "react";
import { Switch, Route } from "react-router-dom";
import "./App.css";
import "./normalize.css";
import PrivateRoute from "./utils/PrivateRoute";
import AdminLayout from "./layout/AdminLayout";

const users = lazy(() => import("./app/UsersManagement/Users"));
const members = lazy(() => import("./app/Members"));

const Dashboard = lazy(() => import("./app/Dashboard"));
const Login = lazy(() => import("./app/Auth/Login"));
const forgetPassword = lazy(() => import("./app/Auth/ForgetPassword"));
const resetPassword = lazy(() => import("./app/Auth/ResetPassword"));
const master = lazy(() => import("./app/Settings/Masters"));
const alertSetup = lazy(() => import("./app/Settings/AlertSetup"));
const UserActivity = lazy(() => import("./app/Settings/UserActivity"));
const documentManager = lazy(() => import("./app/document"));
const hrDetail = lazy(() => import("./app/HR"));
const hrDataView = lazy(() => import("./app/HRDataView"));
const hrDashboard = lazy(() => import("./app/HRDashboard"));
const report = lazy(() => import("./app/Report"));
const compare = lazy(() => import("./app/Comparision"));
const summary = lazy(() => import("./app/Summary"));

// Finance Routes
const financeWeekly = lazy(() => import("./app/Finance/Weekly"));
const financeMonthly = lazy(() => import("./app/Finance/Monthly"));
const financeQuarterly = lazy(() => import("./app/Finance/Quarterly"));
const AsyncNotFound = lazy(() =>
  import("./app/ExtraPages/component/NotFoundPage")
);

function App() {
  return (
    <Switch>
      <Route exact path={"/"} component={Login} />
      <Route exact path={"/forgot-password"} component={forgetPassword} />
      <Route exact path={"/reset-password"} component={resetPassword} />
      <PrivateRoute
        path="/dashboard"
        layout={AdminLayout}
        component={Dashboard}
        role={["HR", "ADMIN"]}
      />
      <PrivateRoute
        path="/hr"
        layout={AdminLayout}
        component={hrDetail}
        role={["HR"]}
      />
      <PrivateRoute
        path="/reports/hr-compile"
        layout={AdminLayout}
        component={hrDataView}
        role={["HR"]}
      />
      <PrivateRoute
        path="/hr-dashboard"
        layout={AdminLayout}
        component={hrDashboard}
        role={["HR, ADMIN"]}
      />
      <PrivateRoute
        path="/reports/report"
        layout={AdminLayout}
        component={report}
        role={["HR", "ADMIN", "FINANCE"]}
      />
      <PrivateRoute
        path="/settings/members"
        layout={AdminLayout}
        component={members}
        role={["ADMIN"]}
      />
      <PrivateRoute
        path="/reports/compare"
        layout={AdminLayout}
        component={compare}
        role={["HR"]}
      />
      <PrivateRoute
        path="/reports/summary"
        layout={AdminLayout}
        component={summary}
        role={["HR"]}
      />
      <PrivateRoute
        path="/settings/users"
        layout={AdminLayout}
        component={users}
        role={["ADMIN"]}
      />
      <PrivateRoute
        path="/settings/master"
        layout={AdminLayout}
        component={master}
        role={["ADMIN"]}
      />
      <PrivateRoute
        path="/settings/alert-setup"
        layout={AdminLayout}
        component={alertSetup}
        role={["ADMIN"]}
      />
      <PrivateRoute
        path="/settings/user-activity"
        layout={AdminLayout}
        component={UserActivity}
        role={["ADMIN"]}
      />

      <PrivateRoute
        path="/document"
        layout={AdminLayout}
        component={documentManager}
        role={["ADMIN"]}
      />

      {/* Finance Routes */}
      <PrivateRoute
        path="/finance/weekly"
        layout={AdminLayout}
        component={financeWeekly}
        role={["FINANCE"]}
      />
      <PrivateRoute
        path="/finance/monthly"
        layout={AdminLayout}
        component={financeMonthly}
        role={["FINANCE"]}
      />
      <PrivateRoute
        path="/finance/quarterly"
        layout={AdminLayout}
        component={financeQuarterly}
        role={["FINANCE"]}
      />
      <Route path="/404" component={AsyncNotFound} />
    </Switch>
  );
}

export default App;
